'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnfiledDocumentsQuery = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _bson = require('bson');

var _SystemNode2 = require('../abstract/SystemNode');

var _SystemNode3 = _interopRequireDefault(_SystemNode2);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnfiledDocumentsQuery = exports.UnfiledDocumentsQuery = function (_SystemNode) {
    (0, _inherits3.default)(UnfiledDocumentsQuery, _SystemNode);

    function UnfiledDocumentsQuery() {
        (0, _classCallCheck3.default)(this, UnfiledDocumentsQuery);
        return (0, _possibleConstructorReturn3.default)(this, (UnfiledDocumentsQuery.__proto__ || (0, _getPrototypeOf2.default)(UnfiledDocumentsQuery)).apply(this, arguments));
    }

    (0, _createClass3.default)(UnfiledDocumentsQuery, [{
        key: 'toQueryFragment',
        value: function toQueryFragment() {
            var queryFragment = {
                documentStatus: 'unindexed',
                binderId: this.binderId,
                conversionStatus: { $ne: 'new' }
            };
            if (this.documentId) {
                queryFragment._id = new _bson.ObjectId(this.documentId);
            }
            return queryFragment;
        }
    }, {
        key: 'binderId',
        get: function get() {
            return this.data.binderId;
        },
        set: function set(value) {
            this.data.binderId = value;
        }
    }, {
        key: 'documentId',
        get: function get() {
            return this.data.documentId;
        },
        set: function set(value) {
            this.data.documentId = value;
        }
    }]);
    return UnfiledDocumentsQuery;
}(_SystemNode3.default);

UnfiledDocumentsQuery.accepts = [];
UnfiledDocumentsQuery.canHaveChildren = false;
UnfiledDocumentsQuery.terminalNode = true;
UnfiledDocumentsQuery.displayName = 'Unfiled Documents Query';

_QueryNodeRegistry2.default.register(UnfiledDocumentsQuery);
exports.default = UnfiledDocumentsQuery;